import styled from 'styled-components';

export const StyledPriceInformation = styled.div`
  display: flex;
  width: 100%;
  color: $text-color-lighten;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: none;
`;

export const StyledInfoPageLink = styled.div`
  display: flex;
  color: inherit;
  align-items: center;
  text-decoration: underline;
  margin-left: auto;
`;
